
      import API from "!../../../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../../node_modules/style-loader/dist/runtime/styleDomAPI.js";
      
      import setAttributes from "!../../../../../node_modules/style-loader/dist/runtime/setAttributesWithAttributesAndNonce.js";
      import insertStyleElement from "!../../../../../node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../../../node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./toast.scss";
      
      

var options = {"attributes":{"id":"@playkit-js/ui-managers"}};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;
options.insert = function (styleElement) {
    if (window.kalturaGlobalConfig && typeof window.kalturaGlobalConfig.stylesNonce === 'string') {
        styleElement.setAttribute('nonce', window.kalturaGlobalConfig.stylesNonce);
    }
    document.head.appendChild(styleElement);
};
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./toast.scss";
       export default content && content.locals ? content.locals : undefined;
